import React from 'react';
import { createStyles, makeStyles } from '@mui/styles';
import { Skeleton } from '@mui/material';
import MemberGroupListItem from './MemberGroupListItem';
import { GroupMemberHookReturn } from '../../hooks/useGroupMemberHook';

const useStyles = makeStyles(() =>
    createStyles({
        listContainer: {
            width: '96%',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            paddingBottom: '64px'
        },
        errorContainer: {
            width: '96%',
            boxSizing: 'border-box',
            backgroundColor: 'white',
            border: '1px solid #E3E3FA',
            borderRadius: 10
        },
        errorText: {
            textAlign: 'left',
            color: '#1F2152',
            fontSize: '1.2rem',
            padding: '1em',
            margin: 0,
            fontWeight: 600
        }
    })
);

type MemberGroupListProps = {
    type: 'deployment' | 'organization';
    hook: GroupMemberHookReturn;
};

const MemberGroupList: React.FC<MemberGroupListProps> = ({ type, hook }) => {
    const classes = useStyles();
    const { groups, groupsError, isGroupsLoading, fetchMembers } = hook;

    const handleViewMembers = (groupId: number) => {
        fetchMembers(groupId);
    };

    if (isGroupsLoading) {
        return (
            <div className={classes.listContainer}>
                {[1, 2, 3, 4].map((i) => (
                    <Skeleton
                        key={i}
                        variant="rounded"
                        height={150}
                        animation="wave"
                    />
                ))}
            </div>
        );
    }

    if (groupsError) {
        return (
            <div className={classes.errorContainer}>
                <p className={classes.errorText}>
                    Error loading groups: {groupsError.message}
                </p>
            </div>
        );
    }

    if (!groups || groups.length === 0) {
        return (
            <div className={classes.errorContainer}>
                <p className={classes.errorText}>
                    No groups found
                </p>
            </div>
        );
    }

    return (
        <div className={classes.listContainer}>
            {groups.map((group) => (
                <MemberGroupListItem
                    key={type === 'deployment' ? "deployment#" + group.id : "organization#" + group.id}
                    groupId={group.id}
                    title={group.title}
                    tags={group.tags}
                    stats={group.stats}
                    onViewMembers={() => handleViewMembers(group.id)}
                    hook={hook}
                />
            ))}
        </div>
    );
};

export default MemberGroupList; 